import React, { Fragment } from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { H1, H3 } from 'app/common/typography'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { Breadcrumb } from 'app/common/breadcrumb'

type Props = {
    intl: IntlShape
}

const Baseline = injectIntl((props: Props) => {
    const { intl } = props

    return (
        <Fragment>
            <Breadcrumb
                breadcrumbArray={[
                    {
                        title: intl.formatMessage({
                            id: 'timeline.breadcrumb.end'
                        })
                    }
                ]}
            />
            <BaselineContainer>
                <FormattedMessage id="timeline.baseline">
                    {(text: string) => <StyledH1>{text}</StyledH1>}
                </FormattedMessage>
                <FormattedMessage id="timeline.subBaseline">
                    {(text: string) => <StyledH3>{text}</StyledH3>}
                </FormattedMessage>
            </BaselineContainer>
        </Fragment>
    )
})

const StyledH1 = styled(H1)`
    margin-bottom: 10px;
    ${media.medium`
        font-size: 38px;
        line-height: 44px;
    `};
    ${media.large`
        font-size: 46px;
        line-height: 50px;
    `};
`
const StyledH3 = styled(H3)`
    margin-bottom: 15px;
    ${media.medium`
        font-size: 26px;
        line-height: 35px;
    `};
    ${media.large`
        font-size: 32px;
        line-height: 36px;
        margin-bottom: 30px;
    `};
`
const BaselineContainer = styled.div`
    border-bottom: 1px solid ${colors.lightGrey};
    margin-bottom: 15px;
    ${media.large`
        margin-bottom: 30px;
    `};
`

export { Baseline }
